import { Component, OnInit } from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
@Component({
  selector: 'app-more-participant-menu',
  templateUrl: './more-participant-menu.component.html',
  styleUrls: ['./more-participant-menu.component.css']
})
export class MoreParticipantMenuComponent implements OnInit {

  constructor() { }

  // myControl = new FormControl();
  // options: string[] = ['One', 'Two', 'Three'];
  

  ngOnInit(): void {
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value)),
    );

  }

  myControl = new UntypedFormControl();
  options: string[] = ['lakshmikala@chn.aithent.com', 'shivakumar@chn.aithent.com', 'tlavanya@chn.aithent.com','praveenputta@chn.aithent.com','majithkumar@chn.aithent.com'];
  filteredOptions!: Observable<string[]>;
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().includes(filterValue));
}
}